import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { HttpErrorHandler } from 'app/shared/http-error-handler';
import { List } from 'app/shared/list';

import { SaleOffer, SaleOfferFilter } from 'app/_models/commercialization';
import { SaleOfferService } from 'app/_services/commercialization.service';

@Component({
  selector: 'app-sale-offers',
  templateUrl: './sale-offers-list.component.html',
})
export class SaleOffersListComponent extends List implements OnInit {
  filter: SaleOfferFilter = new SaleOfferFilter();
  loading: boolean;
  saleOffers: Array<any> = [];
  saleOfferExpanded: SaleOffer;
  otherInterestedClients: any[] = [];
  // Mixins prototypes
  errorMessage: string;
  errorRouter: Router;
  constructor(
    private saleOfferService: SaleOfferService,
    private router: Router,
    private route: ActivatedRoute,
    protected httpErrorHandler: HttpErrorHandler
  ) {
    super(saleOfferService, new SaleOffer(), router, route);
  }

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      this.loading = true;
      if (Object.keys(params).length === 0) {
        this.router.navigate(['/sale-offers', SaleOfferFilter.serializeRouterParams(this.filter)]);
        return;
      }
      this.initList('sale-offers', this.filter).then((result) => {
        this.loading = false;
      });
    });
  }
  getSaleOffer(id) {
    if (!this.saleOfferExpanded || id !== this.saleOfferExpanded.id) {
      this.saleOfferService.getSaleOffer(id).subscribe(
        (saleOffer) => {
          this.saleOfferExpanded = saleOffer;
          if (saleOffer.client_messages) {
            this.otherInterestedClients = saleOffer.client_messages.filter(function (el) {
              if (el.client.id !== saleOffer.buyer.client.id && el.purchase_tried_date) {
                return el;
              }
            });
          }
          this.loading = false;
        },
        (error) => {
          console.error(error);
          this.loading = false;
        }
      );
    } else {
      this.saleOfferExpanded = null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/sale-offers/sale-offers-list/sale-offers-list.component.ts